import { render, staticRenderFns } from "./TestHomePage.vue?vue&type=template&id=45b906b6&scoped=true&"
import script from "./TestHomePage.vue?vue&type=script&lang=js&"
export * from "./TestHomePage.vue?vue&type=script&lang=js&"
import style0 from "./TestHomePage.vue?vue&type=style&index=0&id=45b906b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b906b6",
  null
  
)

export default component.exports